const cachios = require('cachios');
const axios = require('axios');

// Only the real production hostname reaches the production API; localhost uses
// the bare dev server, and anything else (.lan addresses) fails safe to the
// Caddy-proxied dev API — never production.
const apiUrl = (location.hostname === 'app.my247ed.com') ? 'https://api.my247ed.com/'
    : (location.hostname === 'localhost') ? 'http://localhost:3000/'
    : 'https://api.my247ed.lan/';
const axiosInstance = axios.create({
    baseURL:  apiUrl
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
const client = cachios.create(axiosInstance, {
    stdTTL: 120
});

const stripePK = (location.hostname === 'app.my247ed.com') ? 'pk_live_Ylvt97HVw0adW0ilmHdioiT600COyL1MJh' : 'pk_test_Mx213mFpG7pCFQ9szH6NQ9ER00rERfI0s8';

export {client, axiosInstance, apiUrl, stripePK};
